import { Component, EventEmitter, Input, OnInit, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ExplainerDialogService } from 'app/core/explainer-dialog.service';
import { Subscription } from 'rxjs';
import { ThemeService } from '../services/theme.service';
import { ChartMetrics } from './chart-legends';
import { PageTitle } from '../utils/page-title';

@Component({
  selector: 'app-chart-legends',
  templateUrl: './chart-legends.component.html',
  styleUrls: ['./chart-legends.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChartLegendsComponent implements OnInit, OnChanges {
  @Input() dataLegends: any;
  @Input() typeMetrics: ChartMetrics[];
  @Input() hasInputFields: boolean;
  @Input() hasTagSurvey: boolean;
  @Input() inActiveCampaign: boolean;
  @Input() isGridLegend: boolean;
  @Input() isShortLegend: boolean;
  /** Round 8px dot + 11px label, matching app-analytics-chip-list's legend look, instead of the
   * default square swatch/13px label. */
  @Input() roundDot: boolean;
  @Input() choosable: boolean;
  @Input() pageTitle: PageTitle;
  @Output() toggleDatasetChart = new EventEmitter();
  public PageTitle = PageTitle;
  public isDarkThemeSub: Subscription;
  public isDarkTheme: boolean;
  public dataLegendsResult: any = [];
  constructor(
    public themeService: ThemeService,
    public explainerDialogService: ExplainerDialogService,
  ) {}

  ngOnInit() {
    this.isDarkThemeSub = this.themeService.isDarkThemeBS.subscribe((isDarkTheme) => {
      this.isDarkTheme = isDarkTheme;
      this.setValueLegends();
    });
  }

  ngOnChanges() {
    this.setValueLegends();
  }

  /**
   * Positions the explainer popover at the label. The layout's click listener only does this for
   * elements classed `explainer`, which here styles the info icon rather than a text label.
   */
  openPrompt(item: ChartMetrics, event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    this.explainerDialogService.setContentExpainer(item.explainer);
    this.explainerDialogService.explainerBS.next({
      top: target.getBoundingClientRect().top + window.pageYOffset,
      left: target.getBoundingClientRect().left + window.pageXOffset,
      isExisted: true,
      menuIsOpen: true,
    });
  }

  setValueLegends() {
    if (this.typeMetrics && this.dataLegends && !Array.isArray(this.dataLegends)) {
      this.dataLegendsResult = this.typeMetrics.map((metrics) => {
        return {
          ...metrics,
          value:
            metrics.name === 'view'
              ? this.dataLegends.views
              : metrics.name === 'clickthrough'
                ? this.dataLegends.clickthroughs
                : metrics.name === 'couponsCopied'
                  ? this.dataLegends.couponsCopied
                  : metrics.name === 'share'
                    ? this.dataLegends.share
                    : metrics.name === 'surveyResponses'
                      ? this.dataLegends.surveyTotal || this.dataLegends.surveyResponses
                      : this.dataLegends.conversionTotal || this.dataLegends.conversions,
          percent: metrics.percent
            ? this.hasTagSurvey
              ? this.dataLegends.surveyRate
              : this.hasInputFields && metrics.name !== 'couponsCopied'
                ? this.dataLegends.conversionRate
                : this.dataLegends.couponsCopied && metrics.name === 'couponsCopied'
                  ? this.dataLegends.couponsCopiedRate
                  : this.dataLegends.ctr
            : 0,
        };
      });
    } else {
      if (this.dataLegends) {
        if (this.dataLegends.some((item) => item.name === 'unidentifiedVisitors')) {
          this.dataLegendsResult = this.dataLegends.map((item) => {
            return item.name === 'unidentifiedVisitors' ? { ...item, color: this.isDarkTheme ? 'gray' : '#555' } : item;
          });
        } else {
          this.dataLegendsResult = this.dataLegends;
        }
      }
    }
  }
}
